module.exports = __webpack_public_path__ + "static/media/YM66_4.51e54182.jpg";